import React, { lazy, Suspense, useEffect, useRef, useState } from "react"
import lt from 'date-fns/locale/lt';
import { differenceInCalendarDays } from "date-fns";
import format from 'date-fns/format';
import { useCheckAvailability } from "../../hooks/useSpots";
import { useNavigate } from "react-router-dom";
import CalendarIcon from "../../icons/calendar.svg"
import "./Reservation.scss"

export const toUTCDateOnly = (date: Date) => {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
};

const DateRange = lazy(() => import("react-date-range").then(module => ({ default: module.DateRange })));

const OccupancyCheckBox = () => {
    const dateRangeRef = useRef<HTMLDivElement>(null);
    const [openDate, setOpenDate] = useState<boolean>(false);

    const [parkingDate, setParkingDate] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection'
        } as any
    ]);
    const { mutate: checkAvailability } = useCheckAvailability();

    const [isSpotFree, setIsSpotFree] = useState(true);
    const [selectedDays, setIsSelectedMoreThan1Days] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    const handleOutsideClick = (event: MouseEvent) => {
        if (dateRangeRef.current && !dateRangeRef.current.contains(event.target as Node)) {
            setOpenDate(false);
        }
    };

    const toUTCDate = (date: Date) => {
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    };

    const handleDateChange = (item: any) => {
        const { startDate, endDate } = item.selection;

        const adjustedStartDate = toUTCDate(startDate);
        const adjustedEndDate = toUTCDate(endDate);

        setParkingDate([{
            startDate: adjustedStartDate,
            endDate: adjustedEndDate,
            key: 'selection'
        }]);

        if (adjustedStartDate && adjustedEndDate && differenceInCalendarDays(adjustedEndDate, adjustedStartDate) > 0) {
            setOpenDate(false);
        }
    };

    const onSubmit = async () => {
        const selectedStartDate = parkingDate[0].startDate;
        const selectedEndDate = parkingDate[0].endDate;
        const diffInDays = differenceInCalendarDays(selectedEndDate, selectedStartDate);

        if (diffInDays < 1) {
            setIsSelectedMoreThan1Days(false);
            return;
        }

        setIsSelectedMoreThan1Days(true);

        checkAvailability({ startDate: toUTCDateOnly(selectedStartDate), endDate: toUTCDateOnly(selectedEndDate) }, {
            onSuccess: (result) => {
                if (result.success) {
                    setIsSpotFree(true);
                    navigate("/reservationPage", { state: { parkingDate, emptySpot: result.spotId } });
                    sessionStorage.setItem("startDate", JSON.stringify(selectedStartDate));
                    sessionStorage.setItem("endDate", JSON.stringify(selectedEndDate));
                } else {
                    setIsSpotFree(false);
                }
            },
            onError: (error) => {
                console.error("Error checking availability:", error);
                setIsSpotFree(false);
            }
        });
    };

    return (
        <div className="occupancy-check-box-container">
            <h2>RASKITE SAVO STOVĖJIMO VIETĄ</h2>
            <div className="description">Pasirinkite stovėjimo laikotarpį</div>
            <div ref={dateRangeRef} >
                <button onClick={() => setOpenDate(true)} className="header-date-input-text">
                    <span className="calendar-icon"><img src={CalendarIcon} /></span>
                    <div>Pasirinkite datas</div>
                </button>

                {openDate && (
                    <div className="modal-overlay" onClick={() => setOpenDate(false)}>
                        <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                            <Suspense fallback={<div>Loading...</div>}>
                                <DateRange
                                    editableDateInputs
                                    ranges={parkingDate}
                                    onChange={handleDateChange}
                                    locale={lt}
                                    minDate={new Date()}
                                />
                            </Suspense>
                        </div>
                    </div>
                )}
            </div>
            <div className="date-box-container">
                <div className="date-box">
                    <div className="date-box-label">Atvykimas</div>
                    <div className="date-box-value">{`${format(parkingDate[0].startDate, "yyyy-MM-dd")}`}</div>
                </div>
                <div className="date-box">
                    <div className="date-box-label">Isvykimas</div>
                    <div className="date-box-value">{`${format(parkingDate[0].endDate, "yyyy-MM-dd")}`}</div>
                </div>
            </div>

            <button type="submit" onClick={onSubmit} className="check-button">
                Tikrinti užimtumą
            </button>
            {!isSpotFree && <div className="no-spots-error">Apgailestaujame, pasirinktomis dienomis laisvų vietų nėra</div>}
            {!selectedDays && <div className="no-spots-error">Norint atlikti rezervaciją reikia pasirinkti bent 2 dienas</div>}
        </div>
    )
}

export default OccupancyCheckBox